<template>
    <div class="app-footer bg-teal-950">
        <layout-contained>
            <div class="py-16 grid lg:grid-cols-12 gap-8 text-gray-200">
                <div class="flex flex-col space-y-4 col-span-5">
                    <div class="text-gray-100 font-bold">
                        &copy; {{ $config.public.companyNameLong }} trading as GSC Tanker Care
                    </div>
                    <div>
                        {{ $config.public.siteStrapline }}
                    </div>
                    <div class="pt-2">
                        Company No. 09690792
                        <br />VAT No. GB 268 9226 59
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="text-gray-100 mb-4 font-bold">Contact</div>
                    <div class="mb-4">
                        <a href="mailto: info@globalsupplyconnections.co.uk">info@globalsupplyconnections.co.uk</a>
                    </div>
                    <address class="not-italic">
                        17 Mornington Road
                        <br />Sale <br />England <br />M33 2DA
                    </address>
                </div>
                <div class="col-span-2">
                    <div class="text-gray-100 mb-4 font-bold">Sitemap</div>
                    <ul class="list-none text-gray-300">
                        <li class="mb-0">
                            <NuxtLink class="hover:underline" to="/">Home</NuxtLink>
                        </li>
                        <li class="mb-0">
                            <NuxtLink class="hover:underline" to="/contact">Contact</NuxtLink>
                        </li>
                        <li class="mb-0">
                            <NuxtLink class="hover:underline" to="/terms">Terms</NuxtLink>
                        </li>
                    </ul>
                </div>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
};
</script>
